// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2umnL","right":"styles_right__2XRzv"};